function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { useCallback, useRef, useState } from "react";
import split from "just-split";
import Flicking from "@egjs/react-flicking";
import { useUIDSeed } from "react-uid";
import { IconDetailsGridCard, Section, SectionHeader, PaginationDots } from "../../molecules";
import { useIsDesktop } from "../../../hooks";
export var IconDetailsGridCarousel = function(_param) {
    var cards = _param.cards, mobile_only = _param.mobile_only, className = _param.className, enableLines = _param.enableLines, headerProps = _objectWithoutProperties(_param, [
        "cards",
        "mobile_only",
        "className",
        "enableLines"
    ]);
    var seed = useUIDSeed();
    var ref = useRef(null);
    var groupedCards = split(cards, 3);
    var isDesktop = useIsDesktop();
    var ref1 = _slicedToArray(useState(0), 2), activeIndex = ref1[0], setActiveIndex = ref1[1];
    var handleChangeOrRestore = useCallback(function(event) {
        setActiveIndex(event.index);
    }, []);
    var handlePaginationClick = useCallback(function(index) {
        var ref1;
        (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.moveTo(index);
    }, []);
    var content = /*#__PURE__*/ React.createElement(Section, {
        container: true,
        lines: enableLines ? "dark" : false,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mb-9 md:mb-12"
    }, /*#__PURE__*/ React.createElement(SectionHeader, _extends({
        variant: "mobile-centered"
    }, headerProps))), /*#__PURE__*/ React.createElement(Flicking, {
        ref: ref,
        preventClickOnDrag: true,
        bound: true,
        align: "prev",
        moveType: "strict",
        onWillChange: handleChangeOrRestore,
        onWillRestore: handleChangeOrRestore
    }, isDesktop && groupedCards.map(function(group) {
        return /*#__PURE__*/ React.createElement("div", {
            key: seed(group),
            className: "grid-cols-3 gap-7 flicking-panel shrink-0 w-full hidden md:grid"
        }, group.map(function(card) {
            return /*#__PURE__*/ React.createElement("div", {
                key: seed(card)
            }, /*#__PURE__*/ React.createElement(IconDetailsGridCard, _extends({
                noTitleBorder: true
            }, card)));
        }));
    }), !isDesktop && cards.map(function(card) {
        return /*#__PURE__*/ React.createElement("div", {
            key: seed(card),
            className: "flicking-panel shrink-0 w-full px-5 md:hidden"
        }, /*#__PURE__*/ React.createElement(IconDetailsGridCard, _extends({
            noTitleBorder: true
        }, card)));
    })), /*#__PURE__*/ React.createElement("div", {
        className: "mt-10"
    }, /*#__PURE__*/ React.createElement(PaginationDots, {
        className: "hidden md:flex",
        count: groupedCards.length,
        activeIndex: activeIndex,
        onClick: handlePaginationClick
    }), /*#__PURE__*/ React.createElement(PaginationDots, {
        className: "flex md:hidden",
        count: cards.length,
        activeIndex: activeIndex,
        onClick: handlePaginationClick
    })));
    return mobile_only ? /*#__PURE__*/ React.createElement("div", {
        className: "lg:hidden"
    }, content) : content;
};

//# sourceMappingURL=IconDetailsGridCarousel.js.map